<template>
  <div id="home">
    <div style="font-family: GochiHand">.</div>
    <transition name="component-fade" mode="out-in">
      <b-container
        v-if="submitStatus !== 'OK' || windowWidth <= 700"
        key="uncomplete"
      >
        <div id="img-container">
          <img src="@/assets/images/contracts-img.png" alt="Contract" />
        </div>

        <div id="right-container">
          <!-- <img
            src="@/assets/images/crib-club-logo-stacked.svg"
            alt="Crib Club Logo"
          /> -->
          <img
            src="@/assets/images/crib-club-logo-new.png"
            alt="Crib Club Logo"
          />
          <div
            v-if="submitStatus === 'OK' && windowWidth <= 700"
            id="success-form"
          >
            <div id="success-text">
              <h2>SUCCESS!</h2>
              <p>
                Your certificate should download shortly. If you'd like to make
                a new certificate press the button below.
              </p>
              <b-button class="submitButton" @click="submitStatus = null"
                >New Contract</b-button
              >
            </div>
          </div>

          <div v-if="submitStatus !== 'OK'" id="form-container">
            <h2>Sign Up</h2>
            <h3>for your Crib Club Contract</h3>
            <p>
              Make your little one an official member of our Chicago Bears team!
              The Chicago Bears Crib Club, brought to you by Advocate Health
              Care, is excited to offer new and current members the opportunity
              to personalize a Baby’s First Contract.
            </p>
            <p>
              Fill out the form below to receive a digital version of your
              Baby’s First Contract to print and sign. Share your signed Crib
              Club contract with us by tagging @ChicagoBears and #BearsCribClub.
            </p>

            <form id="nameSubmission" @submit.prevent="submit">
              <div class="form-entry-container">
                <!-- First Name -->
                <div id="firstName">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.firstName.$error }"
                  >
                    <label class="form__label">First Name*</label>
                    <input
                      class="form__input"
                      v-model.trim="$v.firstName.$model"
                      placeholder="First Name"
                    />
                  </div>
                  <div class="error" v-if="$v.firstName.$error">
                    <p v-if="!$v.firstName.required">Field is required</p>
                    <p v-if="!$v.firstName.cleanName">Potty mouth</p>
                  </div>
                </div>
                <!-- Last Name -->
                <div id="lastName">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.lastName.$error }"
                  >
                    <label class="form__label">Last Name*</label>
                    <input
                      class="form__input"
                      v-model.trim="$v.lastName.$model"
                      placeholder="Last Name"
                    />
                  </div>
                  <div class="error" v-if="$v.lastName.$error">
                    <p v-if="!$v.lastName.required">Field is required</p>
                    <p v-if="!$v.lastName.cleanName">Potty mouth</p>
                  </div>
                </div>
                <!-- Submit -->
                <div id="submit">
                  <p>
                    <input
                      class="submitButton"
                      type="submit"
                      value="Create Contract"
                    />
                  </p>
                  <div class="error" v-if="submitStatus === 'ERROR'">
                    <p>Form needs to be completed properly</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-container>
      <div
        id="pdf-section"
        v-if="submitStatus === 'OK' && windowWidth > 700"
        key="complete"
      >
        <b-container id="pdf-container">
          <b-button id="back-button" @click="submitStatus = null"
            ><img src="@/assets/images/back-button.svg" alt="Back Button"
          /></b-button>
          <div id="iframe-container">
            <!-- <iframe id="pdf" style="width: 100%; height: 90%"></iframe> -->
            <canvas id="canvas" width="700" height="906"></canvas>
          </div>
        </b-container>
        <div id="buttons-section">
          <b-button
            id="downloadButton"
            class="submitButton"
            @click="downloadButton"
          >
            Download <img src="@/assets/images/download-icon.svg" alt=""
          /></b-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { downloadPDFButton } from "@/helpers/modifyPDF";
import { required, alpha } from "vuelidate/lib/validators";

const cleanName = (name) => {
  var Filter = require("bad-words"),
    filter = new Filter({ regex: /\*|\.|$/gi });
  return !filter.isProfane(name);
};

export default {
  name: "Home",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      errors: [],
      submitStatus: null,
      windowWidth: window.innerWidth,
    };
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        console.log(this.submitStatus);
      } else {
        if (this.windowWidth <= 700) {
          this.submitStatus = "OK";
          this.downloadButton();
        } else {
          this.submitStatus = "OK";
          //downloadPDF(this.firstName.toUpperCase(), this.lastName.toUpperCase());
          await new Promise((r) => setTimeout(r, 400));
          this.showJpeg(
            //"https://digital.library.unt.edu/ark:/67531/metadc11051/m1/1/med_res/",
            "https://bears.vipfanportal.com/cribclub/files/BabyContractIMG.jpg",
            this.firstName.toUpperCase() + " " + this.lastName.toUpperCase()
          );
        }
      }
    },
    sendEmail() {
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
          window.Email &&
            window.Email.send({
              SecureToken: "4cff8fe8-69e7-4133-878c-b9a2f2002005",
              To: this.email,
              From: "raman_heera@hotmail.com",
              Subject: "Test",
              Body: this.firstName + " " + this.lastName,
              Attachments: [
                {
                  name: "smtpjs.png",
                  path: "https://networkprogramming.files.wordpress.com/2017/11/smtpjs.png",
                },
              ],
            }).then((message) => alert(message));
        })
        .catch(() => {
          // Failed to fetch script
        });
    },
    downloadButton() {
      downloadPDFButton(
        this.firstName.toUpperCase(),
        this.lastName.toUpperCase()
      );
    },
    showJpeg(imagePath, text) {
      var circle_canvas = document.getElementById("canvas");
      var context = circle_canvas.getContext("2d");

      // Draw Image function
      var img = new Image();
      img.src = imagePath;
      img.onload = function () {
        context.drawImage(img, 0, 0);
        context.lineWidth = 1;
        context.fillStyle = "#656565";
        context.lineStyle = "#656565";
        context.font = "15px GochiHand";
        context.fillText(text, 400, 190);
      };
    },
  },
  validations: {
    firstName: {
      required,
      alpha,
      cleanName,
    },
    lastName: {
      required,
      alpha,
      cleanName,
    },
  },
};
</script>

<style lang="scss" scoped>
#home {
  position: relative;
  background: url("../../src/assets/images/wall4.png") repeat;
  overflow: hidden;
  .container {
    border-radius: 5px;

    margin: 10% auto;
    display: flex;
    //gap: -1px;
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.3);
    background: none;
    padding: 0;
    max-height: 906px;
    @media only screen and (max-width: $lg) {
      margin: 10% auto;
      max-width: 758px;
    }
    @media only screen and (max-width: $md) {
      flex-direction: column;
      margin: 20% auto;
    }
    #img-container {
      @media only screen and (min-width: $md) {
        flex-basis: 50%;
      }
      border-radius: 5px 5px 0 0;
      @media only screen and (max-width: $md) {
        overflow: hidden;
        width: 100%;
        height: calc(100vw / 16 * 8);
        display: flex;
        //align-items: center;
        border-radius: 0;
      }
      img {
        border-radius: 5px 0 0 5px;

        height: 100%;
        background-color: transparent;
        object-fit: cover;
        //object-position: 50% 50%;

        @media only screen and (max-width: $md) {
          width: 100%;
          object-fit: cover;
          object-position: 50% 50%;
          border-radius: 0;
          //height: 100%;
        }
      }
    }
    #right-container {
      @media only screen and (min-width: $md) {
        flex-basis: 50.5%;
      }
      background-color: $bears-navy;
      border-radius: 0 5px 5px 0;
      @media only screen and (max-width: $md) {
        border-radius: 0;
      }
      img {
        position: absolute;
        margin: 0 auto;
        text-align: center;
        left: 0;
        right: 0;
        top: 0;
        width: 20%;
        height: auto;

        @media only screen and (max-width: $md) {
          width: 30%;
          top: 2%;
        }
        @media only screen and (max-width: $sm) {
          width: 40%;
          top: 1%;
        }
      }

      #form-container {
        @media only screen and (max-width: $md) {
          margin: 10% 5%;
        }
        margin: 15% 10% 10%;
        text-align: left;
        color: #fff;
        h2 {
          font-weight: 900;
          font-size: 70px;
          text-transform: uppercase;
          margin: 0;
          @media only screen and (max-width: $lg) {
            font-size: 42px;
          }
        }
        h3 {
          color: $bears-orange;
          font-weight: 700;
          font-size: 24px;
          text-transform: uppercase;
          margin: 0 0 5%;
          @media only screen and (max-width: $xl) {
            font-size: 22px;
          }
          @media only screen and (max-width: $lg) {
            font-size: 20px;
            width: 90%;
            line-height: 22px;
          }
        }
        p {
          font-size: 14px;
          @media only screen and (max-width: $md) {
            //padding-right: 8%;
          }
        }
        .form-entry-container {
          margin-top: 30px;
          padding: 0;
          display: grid;
          grid-template:
            "a a a " auto
            "b b  b" auto
            "c c c" auto
            "d . ." auto;
          column-gap: 2em;
          #firstName {
            grid-area: a;
          }
          #lastName {
            grid-area: b;
          }
          #email {
            grid-area: c;
          }
          #submit {
            grid-area: d;
            margin: 10% 0 0;
          }
        }
        .form-group {
          .form__input {
            color: #656565;
            border: 1px solid #cad1d7;
            border-radius: 5px;
            background-color: $light-grey;
            padding: 0.625rem 0.75rem;
            width: 100%;
            height: calc(2.75rem + 2px);
            transition: all 0.5s ease;
            text-transform: uppercase;
          }
          input:focus {
            border-color: $bears-orange;
            //outline: 0;
            -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
              0 0 8px rgba(229, 66, 1, 0.44);
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
              0 0 8px rgba(229, 66, 1, 0.44);
          }
          .form__label {
            text-transform: uppercase;
            font-weight: 600;
            font-size: 13px;
            width: 100%;
            text-align: left;
            transition: color 0.5s ease;
          }
        }
        .form-group--error {
          animation-name: shakeError;
          animation-fill-mode: forwards;
          animation-duration: 0.6s;
          animation-timing-function: ease-in-out;
          .form__label {
            color: #fb6340;
          }
          .form__input {
            border-color: #fb6340;
          }
        }
        .error {
          color: #fb6340;
          font-size: 0.75rem;
          line-height: 1;
          margin-top: -0.5rem;
          p {
            margin: 0;
          }
        }
        @keyframes shakeError {
          0% {
            transform: translateX(0);
          }
          15% {
            transform: translateX(0.375rem);
          }
          30% {
            transform: translateX(-0.375rem);
          }
          45% {
            transform: translateX(0.375rem);
          }
          60% {
            transform: translateX(-0.375rem);
          }
          75% {
            transform: translateX(0.375rem);
          }
          90% {
            transform: translateX(-0.375rem);
          }
          100% {
            transform: translateX(0);
          }
        }
      }
      #success-form {
        margin: 50% auto;
        display: flex;
        align-items: center;
        #success-text {
          margin: 60px 0;
          color: #fff;
          h2 {
            font-weight: 700;
            font-size: 40px;
          }
          p {
            @media only screen and (max-width: $md) {
              padding: 0 10%;
            }
            padding: 0 10%;
          }
        }
      }
    }
  }
  #pdf-section {
    #pdf-container {
      position: relative;
      //height: 970px;
      margin-bottom: 0;
      background: #fff;
      @media only screen and (max-width: $md) {
        //height: 800px;
      }
      @media only screen and (max-width: $sm) {
        //height: 700px;
      }
      @media only screen and (max-width: 400px) {
        //height: 600px;
      }
      #back-button {
        position: absolute;
        top: 23px;
        left: 29px;
        @media only screen and (max-width: $lg) {
          top: 3px;
          left: 15px;
        }
        @media only screen and (max-width: $md) {
          top: 5px;
          left: 15px;
        }
        @media only screen and (max-width: $sm) {
          top: 1px;
          left: 15px;
        }
        @media only screen and (max-width: 400px) {
          top: 1px;
          left: 15px;
        }
        img {
          @media only screen and (max-width: $lg) {
            width: 60px;
            height: auto;
          }
          @media only screen and (max-width: $md) {
            width: 50px;
            height: auto;
          }
          @media only screen and (max-width: $sm) {
            width: 40px;
            height: auto;
          }
          @media only screen and (max-width: 400px) {
            width: 40px;
            height: auto;
          }
        }
      }
      #iframe-container {
        margin: auto auto;
        width: 100%;
        height: 941px;
        iframe {
          max-height: 941px;
        }
        @media only screen and (max-width: $md) {
          //width: $md;
        }
        @media only screen and (max-width: $sm) {
          //width: $sm;
        }
        @media only screen and (max-width: 400px) {
          //width: 350px;
          //height: 500px;
        }
      }
    }

    #buttons-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
        width: 200px;
      }
      #downloadButton {
        position: relative;
        text-align: center;
        padding-left: 3px;
        margin: 30px 0 50px;
        img {
          position: absolute;
          margin-left: 10px;
          top: 10px;
        }
      }
    }
  }
  .submitButton {
    border-radius: 5px;
    color: #fff;
    background-color: $bears-orange;
    text-transform: uppercase;
    padding: 10px 30px;
    font-weight: 700;
    font-size: 15px;
  }
  .component-fade-enter-active,
  .component-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .component-fade-enter,
  .component-fade-leave-to {
    opacity: 0;
  }
}
</style>
